export default [
  ['a', 'z', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p', 'ô', 'à', 'â', 'ä'],
  ['q', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', 'm', 'è', 'é', 'ê', 'ë'],
  ['w', 'x', 'c', 'v', 'b', 'n', 'ç ', 'î', 'ï', 'ù', 'û', 'ü'],
]
